import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { SkuCodesAdapter } from './dto/sku-codes.adapter';
import { SkuCodesController } from './sku-codes.controller';
import { SkuCodes } from './sku-codes.entity';
import {SkuCodesDetail} from './sku-details.entity';

import { SkuCodesService } from './sku-codes.service';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Type1Service } from '@gtpl/shared-services/masters';

@Module({
  imports: [
    TypeOrmModule.forFeature([SkuCodes,SkuCodesDetail]),
    ],
  controllers: [SkuCodesController],
  providers: [SkuCodesService,SkuCodesAdapter,ApplicationExceptionHandler,LogsService,Type1Service],
  exports:[SkuCodesService]
})
export class SkuCodesModule {}
